import AxiosService from '../services/axios-service';
import { removeCpfOrCnpjMask } from '../utils/utils';

export default class AuthRepository {

  static async getUserByCpfOrCnpj(cpfOrCnpj) {
    try {
      const body = {
        cpfOrCnpj: removeCpfOrCnpjMask(cpfOrCnpj)
      };
      const axiosService = new AxiosService();
      const response = await axiosService.put(`webapp/auth/getClientByCpfOrCnpj`, body);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async sendToken(id) {
    try {
      const body = {
        id: id,
      };
      const axiosService = new AxiosService();
      const response = await axiosService.put(`webapp/auth/sendToken`, body);
      return response;
    } catch (error) {
      throw error;
    }
  }

  static async verifyToken(challenge, code) {
    const axiosService = new AxiosService();
    return axiosService.put('webapp/auth/verifyToken', { challenge, code });
  }

  static async login(cpf, verificationProof) {
    return this.authenticate('webapp/auth/login', cpf, verificationProof);
  }

  static async loginSeller(cpf) {
    return this.authenticate('webapp/auth/loginSeller', cpf);
  }

  static async authenticate(url, cpf, verificationProof) {
    try {
      const encodedString = Buffer.from(`${removeCpfOrCnpjMask(cpf)}`).toString('base64');
      const axiosService = new AxiosService();
      const headers = {
        'authorization': `Bearer ${encodedString}`,
      };
      if (verificationProof) {
        headers['x-verification-proof'] = verificationProof;
      }
      const config = {
        headers
      };
      const { accessToken, refreshToken } = await axiosService.get(url, config);
      axiosService.setTokens(accessToken, refreshToken);
      return true;
    } catch (error) {
      throw error;
    }
  }

  static async getUserData() {
    try {
      const axiosService = new AxiosService();
      const response = await axiosService.get(`/webapp/auth/getUserData`);
      return response;
    } catch (error) {
      throw error;
    }
  }
  
}
